module.exports = __webpack_public_path__ + "img/FarbenDesRegenbogens.634c6cb7.svg";